import { caniuse } from '../utils';
export function now() {
    if (caniuse.performanceNow()) {
        return globalThis.performance.now();
    }
    return Date.now();
}
export const time = {
    offset: 0,
    now() {
        return now() + time.offset;
    },
    sync(_now) {
        time.offset = _now - now();
    },
};
export function convertDOMHighResTimeStamp2AbsoluteTime(timestamp) {
    return performance.timeOrigin + timestamp;
}
